<app-info-message></app-info-message>
<div class="background--login">
  <section class="form-container">
    @if (unauthorized()) {
      <div class="warn-box-authentication subtitle-1">
        <mat-icon matPrefix>error</mat-icon>
        {{ unauthorized() }}
      </div>
    }
    <mat-toolbar>
      <mat-toolbar-row>
        <img src="../../assets/images/logo.svg" />
        <h5 class="toolbar-title">Online</h5>
      </mat-toolbar-row>
    </mat-toolbar>
    <div class="content-login">
      <div class="welcome-text subtitle-1">Welcome to EstImage Online</div>
      <form [formGroup]="loginForm" (ngSubmit)="login()">
        <mat-form-field>
          <mat-label>Username</mat-label>
          <input autocomplete="username" name="username" formControlName="username" matInput required />
          @if (loginForm.controls['username'].hasError('required')) {
            <mat-error> Username is <strong>required</strong> </mat-error>
          }
          @if (!loginForm.controls['username'].hasError('required')) {
            <mat-error class="mat-error"> Please enter a valid username </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Password</mat-label>
          <input
            autocomplete="current-password"
            name="password"
            formControlName="password"
            matInput
            required
            [type]="hidePassword ? 'password' : 'text'" />
          <button matIconButton matSuffix type="button" (click)="hidePassword = !hidePassword">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          @if (loginForm.controls['password'].hasError('required')) {
            <mat-error> Password is <strong>required</strong> </mat-error>
          }
        </mat-form-field>
        <button matButton="elevated" type="submit" class="red-button body-1 mt-5" [disabled]="loginForm.invalid">
          LOGIN
        </button>
      </form>
      <button matButton="text" class="body-1 mt-5" (click)="reset(); which = 'RESET'">RESET PASSWORD</button>
    </div>
  </section>
</div>
<app-static-footer />
